RivalIQ.apps.Dashboard.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TitleBar = RivalIQ.views.ItemView.mixin({
        className: 'export-header',
        template: '#dashboardTitlebarTemplate',
        serializeData: function () {
            const me = this;

            return {
                title: me.dashboardModel.getTitle(),
                subtitle: me.getSubtitleArray(),
                exportShowFocusCompany: _.result(me.dashboardModel, 'exportShowFocusCompany', true),
                exportShowCompany: _.result(me.dashboardModel, 'exportShowCompany', false),
                company: me.getCompanyName(),
                focusCompany: me.getFocusCompanyName(),
                companySetName: me.getCompanySetName(),
                // TODO clean up
                timePeriod: me.dashboardModel.getExportTitleBarTimePeriod(),
                branding: RivalIQ.state.view.get('branding') || RivalIQ.state.view.getActiveBranding().toJSON(),
                exportShowLandscapeName: _.result(me.dashboardModel, 'exportShowLandscapeName', true),
                landscapeName: RivalIQ.state.view.get('landscapeName')
            };
        },

        getSubtitleArray: function () {
            const me = this;
            const subtitle = me.dashboardModel.getSubtitle({
                multiLine: true
            });
            return (_.isString(subtitle) ? [subtitle] : subtitle);
        },

        getCompanySetName: function () {
            const me = this;
            // only include the company set name if the company set is not "All" and company sets make sense for this page
            if (me.getProp('companySetDescriptor') !== RivalIQ.state.companySets.none && !me.dashboardModel.isCompanySetFilteringDisabled()) {
                return RivalIQ.state.view.getCompanySetName();
            }
        },

        getFocusCompanyName: function () {
            const me = this;
            const focusCompanyId = me.dashboardModel.getProp('focusCompanyId') || RivalIQ.state.utils.getFocusedCompanyId();
            return RivalIQ.state.landscape.getCompanyById(focusCompanyId).get('name');
        },

        getCompanyName: function () {
            const me = this;

            if (!_.result(me.dashboardModel, 'exportShowCompany', false)) {
                return;
            }
            const companyId = me.dashboardModel.getProp('companyId');
            return RivalIQ.state.landscape.getCompanyById(companyId).get('name');
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        }
    });

    views.TitlePage = views.TitleBar.extend({
        className: 'export-cover-page',
        template: '#pdfCoverPageTemplate'
    });
});
